const values: <T extends object>(obj: T) => T[Extract<keyof T, string>][] =
  Object.values;

export default values;
